
import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import CookieConsent from './CookieConsent';
import LazyImage from '@/components/LazyImage';

const Footer = () => {
  const { t } = useTranslation(); // Use the hook

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex justify-center w-full mb-2">
              <LazyImage 
                src="/images/home/logo.png" 
                alt="PLASA" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              {t('footer.companyDescription')}
            </p>
            <div className="flex space-x-4 hidden">
              <Facebook className="h-5 w-5 text-gray-400 hover:text-white cursor-pointer transition-colors" />
              <Instagram className="h-5 w-5 text-gray-400 hover:text-white cursor-pointer transition-colors" />
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <span className="text-lg font-semibold">{t('footer.quickLinksTitle')}</span>
            <div className="space-y-2">
              <Link to="/" className="block text-gray-300 hover:text-white transition-colors text-sm">
                {t('nav.home')}
              </Link>
              <Link to="/productos" className="block text-gray-300 hover:text-white transition-colors text-sm">
                {t('nav.products')}
              </Link>
              <Link to="/nosotros" className="block text-gray-300 hover:text-white transition-colors text-sm">
                {t('footer.aboutUs')}
              </Link>
              <Link to="/contacto" className="block text-gray-300 hover:text-white transition-colors text-sm">
                {t('nav.contact')}
              </Link>
              <Link to="/aviso-de-privacidad" className="block text-gray-300 hover:text-white transition-colors text-sm">
                {t('footer.privacyPolicy')}
              </Link>
              <Link to="/politica-cookies" className="block text-gray-300 hover:text-white transition-colors text-sm">
                {t('footer.cookiePolicy')}
              </Link>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <span className="text-lg font-semibold">{t('footer.servicesTitle')}</span>
            <div className="space-y-2">
              <p className="text-gray-300 text-sm">{t('footer.serviceVinipielMueble')}</p>
              <p className="text-gray-300 text-sm">{t('footer.serviceSinteticoAutomotriz')}</p>
              <p className="text-gray-300 text-sm">{t('footer.serviceVinilSport')}</p>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <span className="text-lg font-semibold">{t('footer.contactInfoTitle')}</span>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone className="h-4 w-4 plasa-red flex-shrink-0" />
                <span className="text-gray-300 text-sm">(33) 3821 7408 / (33) 1871 5068</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-4 w-4 plasa-red flex-shrink-0" />
                <a href="mailto:plasapcg@plasa.com.mx" className="text-gray-300 text-sm hover:text-white">
plasapcg@plasa.com.mx
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-4 w-4 plasa-red flex-shrink-0 mt-0.5" />
                <span className="text-gray-300 text-sm">
                  Extramuros N° 20<br />
                  La Barca, Jalisco<br />
                  México. CP 47920
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between space-y-6 md:space-y-0">
            <div className="space-y-2">
              {/* Espacio reservado */}
            </div>
            <div className="flex flex-col items-start md:items-center">
              <div className="flex items-center space-x-2">
                <LazyImage 
                  src="/images/home/logo3.png" 
                  alt="PLASA" 
                  className="h-12 w-auto"
                />
                <span className="text-plasa-red text-2xl">®</span>
              </div>
              <div className="mt-2">
                <p className="text-gray-400 text-sm text-left md:text-center">{t('footer.trademark')}</p>
                <p className="text-gray-400 text-sm text-left md:text-center">{t('footer.allRightsReserved')}</p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6 text-sm">
              <p className="text-gray-400 text-sm">© {new Date().getFullYear()} PLASA</p>
            </div>
          </div>
        </div>
      </div>
      <CookieConsent />
    </footer>
  );
};

export default Footer;
